var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "q-pa-md" },
    [
      _c(
        "div",
        { staticClass: "spam-filter-bar q-mb-md" },
        [
          _c("q-input", {
            staticClass: "q-mb-md",
            attrs: {
              type: "textarea",
              rows: "2",
              label: "Full names",
              placeholder:
                "Paste names separated by commas or newlines. Include shows only matching records; Exclude hides them."
            },
            model: {
              value: _vm.nameInput,
              callback: function($$v) {
                _vm.nameInput = $$v
              },
              expression: "nameInput"
            }
          }),
          _c(
            "div",
            {
              staticClass:
                "d-flex align-items-center justify-content-between flex-wrap"
            },
            [
              _c("q-option-group", {
                attrs: {
                  type: "radio",
                  inline: "",
                  color: "primary",
                  options: _vm.modeOptions
                },
                model: {
                  value: _vm.mode,
                  callback: function($$v) {
                    _vm.mode = $$v
                  },
                  expression: "mode"
                }
              }),
              _c(
                "div",
                { staticClass: "d-flex align-items-center" },
                [
                  _c("q-btn", {
                    staticClass: "mr-2",
                    attrs: { label: "Apply", color: "primary" },
                    on: { click: _vm.applyFilter }
                  }),
                  _c("q-btn", {
                    attrs: { flat: "", label: "Clear" },
                    on: { click: _vm.clearFilter }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "spam-batch-bar q-mb-md" }, [
        _c(
          "div",
          { staticClass: "d-flex align-items-center flex-wrap" },
          [
            _c("q-checkbox", {
              staticClass: "mr-3",
              attrs: {
                value:
                  _vm.selectableRows.length > 0 &&
                  _vm.selectableRows.every(function(row) {
                    return _vm.selectedIds.includes(row.id)
                  }),
                disable: !_vm.selectableRows.length,
                label: "Select this page"
              },
              on: { input: _vm.togglePage }
            }),
            _c("span", { staticClass: "mr-3 text-faded" }, [
              _vm._v(_vm._s(_vm.selectedIds.length) + " selected across pages")
            ]),
            _c("q-btn", {
              staticClass: "mr-2",
              attrs: {
                label: "Convert selected",
                color: "primary",
                disable: !_vm.selectedIds.length || _vm.converting,
                loading: _vm.converting
              },
              on: {
                click: function($event) {
                  _vm.convert(_vm.selectedIds)
                }
              }
            }),
            _vm.selectedIds.length
              ? _c("q-btn", {
                  attrs: { flat: "", label: "Clear selection" },
                  on: {
                    click: function($event) {
                      _vm.selectedIds = []
                    }
                  }
                })
              : _vm._e()
          ],
          1
        )
      ]),
      _vm.failures.length
        ? _c(
            "div",
            { staticClass: "text-negative q-mb-md" },
            _vm._l(_vm.failures, function(failure) {
              return _c("div", { key: failure.id }, [
                _vm._v(
                  "\n      Spam #" +
                    _vm._s(failure.id) +
                    ": " +
                    _vm._s(failure.error) +
                    "\n    "
                )
              ])
            })
          )
        : _vm._e(),
      _c("bj-data-table", {
        ref: "dataTable",
        attrs: {
          model: "admin/spams",
          "many-name": "Spams",
          "single-name": "Spam",
          columns: _vm.columns,
          "query-params": _vm.queryParams,
          "with-add-button": false,
          "with-cell-edit-button": false,
          "with-cell-delete-button": false
        },
        on: { fetched: _vm.onFetched },
        scopedSlots: _vm._u([
          {
            key: "cell-select",
            fn: function(ref) {
              var row = ref.row
              return [
                !row.converted_at
                  ? _c("q-checkbox", {
                      attrs: { value: _vm.selectedIds.includes(row.id) },
                      on: {
                        input: function($event) {
                          _vm.toggleSelected(row.id, $event)
                        }
                      }
                    })
                  : _vm._e()
              ]
            }
          },
          {
            key: "cell-created_at",
            fn: function(ref) {
              var row = ref.row
              return [_vm._v("\n      " + _vm._s(row.created_at) + "\n    ")]
            }
          },
          {
            key: "cell-full_name",
            fn: function(ref) {
              var row = ref.row
              return [_vm._v("\n      " + _vm._s(row.full_name) + "\n    ")]
            }
          },
          {
            key: "cell-email",
            fn: function(ref) {
              var row = ref.row
              return [_vm._v("\n      " + _vm._s(row.email) + "\n    ")]
            }
          },
          {
            key: "cell-details",
            fn: function(ref) {
              var row = ref.row
              return [
                _c("div", [_vm._v("Origin: " + _vm._s(row.data.originId))]),
                _c("div", [
                  _vm._v(
                    "Property: " +
                      _vm._s(row.data.property_id) +
                      " · Unit: " +
                      _vm._s(row.data.unit_id || "—")
                  )
                ]),
                _c("div", [_vm._v(_vm._s(row.data.comments))])
              ]
            }
          },
          {
            key: "cell-status",
            fn: function(ref) {
              var row = ref.row
              return [
                row.inquiry_id
                  ? _c(
                      "router-link",
                      {
                        attrs: {
                          to: {
                            name: "app.inquiries",
                            params: { id: row.inquiry_id }
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n        Inquiry #" +
                            _vm._s(row.inquiry_id) +
                            "\n      "
                        )
                      ]
                    )
                  : _c("span", [_vm._v("Pending")])
              ]
            }
          },
          {
            key: "cell-actions",
            fn: function(ref) {
              var row = ref.row
              return [
                !row.converted_at
                  ? _c("q-btn", {
                      attrs: {
                        size: "sm",
                        outline: "",
                        label: "Convert",
                        disable: _vm.converting
                      },
                      on: {
                        click: function($event) {
                          _vm.convert([row.id])
                        }
                      }
                    })
                  : _vm._e()
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }